import AbstractRadioControl from "slotworks/smart-ui/controls/abstract/abstract-radio-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";

export default class AutoplayRadioControl extends AbstractRadioControl implements Control {

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        this.updateValues(options.autoplays.values, options.autoplays.currentValue);
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.autoplays.currentValue = value;
        options.customAutoplayCountSelected = false;

        this.onChange.dispatch(options);
    }
}
